<template>
  <el-upload
      drag
      :v-model="fileUrl"
      :action="uploadUrl"
      :headers="headers"
      :on-success="onUploaded"
      :show-file-list="false"
      :before-upload="beforeUpload"
      class="uploader"
      multiple>
      <div v-show="!fileUrl">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">{{fileLimitTips()}}</div>
      </div>
      <el-row type="flex" justify="center" :span="24" class="img-row">
        <el-col :span="24">
          <img v-show="fileUrl" :src="fileUrl" class="upload-img"/>
        </el-col>
      </el-row>
  </el-upload>
</template>

<script>
import fileApi from '../../models/file'
import { getToken } from '@/lin/utils/cookie'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    filetypes: {
      default() {
        return { PNG: 'image/png', JPG: 'image/jpeg' }
      },
      type: Object,
    },
    maxfilesize: {
      default: 0.5,
      type: Number,
    },
  },
  data() {
    return {
      uploadUrl: fileApi.getUploadUri(),
      headers: { Authorization: getToken('access_token') },
      fileUrl: this.value,
    }
  },
  methods: {
    onUploaded(resp) {
      this.fileUrl = resp[0].url
      this.$emit('on-scuess', resp[0].path)
    },
    fileLimitTips() {
      if (this.filetypes == null) {
        return ''
      }
      let types = ''
      for (const key in this.filetypes) {
        if (types) {
          types += '/'
        }
        types += key
      }
      return `上传文件只能是${types}格式!`
    },
    beforeUpload(file) {
      let typeOk = false
      for (const name in this.filetypes) {
        const tp = this.filetypes[name]
        if (file.type.toLowerCase() === tp.toLowerCase()) {
          typeOk = true
          break
        }
      }
      const isLimit = file.size / 1024 / 1024 < this.maxfilesize

      if (!typeOk) {
        this.$message.error(this.fileLimitTips())
      }
      if (!isLimit) {
        this.$message.error(`上传文件大小不能超过${this.maxfilesize}MB!`)
      }
      return typeOk && isLimit
    },
    reset() {
      this.fileUrl = ''
    },
  },
  mounted() {
    console.debug(this.headers)
  },
  watch: {
    value(newValue) {
      this.fileUrl = newValue
    },
    fileUrl(newValue) {
      this.$emit('input', newValue)
    },
  },
}
</script>

<style lang="scss" scoped>

.uploader {
  width: 100%;

  /deep/.el-upload {
    width: 100%;
  }

  /deep/ .el-upload-dragger {
    width: 100%;
  }
}

.img-row {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
.upload-img {
  height: 100%;
  width: auto;
  text-align: center;
  margin:0 auto;
}
</style>
